// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__xngju","logoutButton":"Sidebar_logoutButton__Hu6kp"};